import React from "react"
import Skeleton from "../Skeleton/Skeleton"
import useDelay from "../../utility/common/useDelay"

import "./CatalogsLoader.scss"

interface CatalogsLoaderProps {
    itemsCount: number
}

const CatalogsLoader: React.FC<CatalogsLoaderProps> = props => {
    const { itemsCount } = props

    const display = useDelay()
    if (!display) return null

    return (
        <div className="catalogs-loader">
            <div className="catalogs-loader__items">
                {new Array<number>(itemsCount).fill(0).map((_, i) => (
                    <div key={i} className="catalogs-loader__item">
                        <div className="catalogs-loader__title">
                            <Skeleton />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CatalogsLoader
